import { AuthProvider, Environment } from '@maia/config';

const applicationBaseUrl = 'https://portal.maia.test.framna-par.cloud';

const locationAppClientId = '739c31ec-aea2-4d51-8857-3bc303e60061';
const workAppClientId = '5ec3814b-b21c-4f95-98cf-75b3071a1a2c';
const groupAppClientId = 'ZlYOjkRXCSDh3F4j6cOLMJkSFC1Gw8Hv';

export const environment: Environment = {
  apiPrefix: '/api/v1',
  baseUrl: applicationBaseUrl,
  production: false,
  contentfulSpaceId: '1ippc6z4tlei',
  contentfulEnvironment: 'staging',
  environmentLabel: 'TEST',
  enableDevbox: true,
  useMocks: false,
  featureFlags: {
    groupAppEnabled: false,
  },
  apps: {
    locationApp: {
      provider: AuthProvider.HelloId,
      clientId: locationAppClientId,
      discoveryUrl: `https://portaal.partou.nl/oauth2/v2/${locationAppClientId}`,
      redirectUrl: `${applicationBaseUrl}/authorize`,
      apiUrl: 'https://maia.test.framna-par.cloud',
      scopes: 'openid profile offline_access',
    },
    workApp: {
      provider: AuthProvider.HelloId,
      clientId: workAppClientId,
      discoveryUrl: `https://portaal.partou.nl/oauth2/v2/${workAppClientId}`,
      redirectUrl: `${applicationBaseUrl}/authorize`,
      apiUrl: 'https://partou-employee.test.m4mapp.com',
      scopes: 'openid profile offline_access',
    },
    groupApp: {
      provider: AuthProvider.KidsKonnekt,
      clientId: groupAppClientId,
      discoveryUrl: 'https://auth.kidskonnect.cloud/.well-known/openid-configuration',
      redirectUrl: `${applicationBaseUrl}/authorize`,
      apiUrl: 'https://api.kvs.test.framna-par.cloud',
      scopes: 'openid offline_access email profile',
    },
  },
};
